import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-toast-alerts',
  template: `
    <fl-toast-alert-container
      class="mobile:show"
      [flSticky]="true"
    ></fl-toast-alert-container>
    <fl-toast-alert-container
      class="mobile:hide"
      [flSticky]="true"
      [flStickyStatic]="true"
    ></fl-toast-alert-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastAlertsComponent {}
